import { styled } from "styled-components";

import { ChevronIcon } from "common/components/icons";
import { UIButton } from "common/components/UIButton";
import { createScrollbarStyle } from "common/styles";

export const Container = styled.div`
  flex-wrap: wrap;
  position: relative;
`;

export const SelectOptionsList = styled.div`
  background-color: ${({ theme }) => theme.colors.searchDropdownBackground};
  border-radius: 5px;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
  max-height: 28.25rem;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 1;

  ${createScrollbarStyle()}

  * {
    border-radius: 5px;
  }
`;

export const NoResultsText = styled.div`
  padding: 1rem;
  color: ${({ theme }) => theme.colors.textBright};
`;

export const DropdownIcon = styled(ChevronIcon)`
  transform: rotate(90deg);
  color: ${({ theme }) => theme.colors.inputText};
`;

export const SelectOption = styled(UIButton)`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  aspect-ratio: 1;
  color: ${({ theme }) => theme.colors.inputText};
`;

export const SelectedOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0.25rem;
`;

export const SelectedOption = styled.button`
  background: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.colors.textFade};
  border: 1px solid ${({ theme }) => theme.colors.chipBorder};
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
  column-gap: 0.25rem;
  background-color: ${({ theme }) => theme.colors.chipBackground};
`;

export const CrossIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 2px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 8px;
  padding: 0.8rem 1rem;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
`;
